import { withGalleryLightBoxDataProps } from 'viewModel/gallery/withGalleryLightBoxDataProps';
import GalleryLightBoxData from 'components/Community/GalleryLightBoxData/GalleryLightBoxData';

export default withGalleryLightBoxDataProps(GalleryLightBoxData);
